// test1070
(1070 && 0);
